import { Component, OnInit } from '@angular/core';
import { IBillingDocument } from '@dch/billing-business-logic';
import { UtilsService } from '../services/utils.service';
import { Router } from '@angular/router';
import { OVERVIEW_PAGE } from '../config/my-bill.constants';

@Component({
  selector: 'my-bill-deferral-successful-new-date-page',
  templateUrl: './deferral-successful-new-date-page.component.html',
  standalone: false,
})
export class DeferralSuccessfulNewDatePageComponent implements OnInit {
  constructor(private utilsService: UtilsService, private router: Router) {}

  billDocument?: IBillingDocument;
  billingAccountNumber?: string;
  selectedNewPaymentDate: string;

  ngOnInit() {
    const { selectedNewPaymentDate } = history.state;
    const { billDocument, billingAccountNumber } =
      this.utilsService.getDeferralDocumentInfoFromStorage();
    if (
      billDocument &&
      (selectedNewPaymentDate || billDocument?.deferralDate)
    ) {
      this.billDocument = billDocument;
      this.billingAccountNumber = billingAccountNumber;
      this.selectedNewPaymentDate = selectedNewPaymentDate;
    } else {
      this.router.navigate([OVERVIEW_PAGE]);
    }
  }
}
